module.exports = {
  id: "goodnessme-box",
  title: "GoodnessMe Box",
  description: "Shop healthy snacks and monthly boxes at GoodnessMe!",
  url: "goodnessme.com.au",

  locationRegion: "AU",
  locationCountries: "AU",
  locationForceRegion: true,
  locationLookupUrl: "https://ipapi.co/json/",

  shopifyPlus: true,
  shopifyApiVersion: "2024-07",
  shopifyShopDomain: "goodnessme-box.myshopify.com",
  shopifyCheckoutUrl: "checkout.goodnessme.com.au",
  shopifyStorefrontToken: "1e9e0f3bb2d640f6248c190ab80d1a88",

  stampedStoreUrl: "goodnessme-box.myshopify.com",
  stampedApiKey: "pubkey-CG99P3NwN8SM614FoVXYB2rVB8k3Y1",

  sanityProjectId: "h6pfw6o3",
  sanityDataset: "production",
  sanityApiVersion: "2022-02-24",

  searchIndex: "goodnessme-search",

  googleAuthClientId: "....apps.googleusercontent.com",
  googleMapsApiKey: "",

  klaviyoApiKey: "HwvvXB",

  emailSender: "hello@goodnessmebox.com",

  facebookAppId: "...",

  rechargeBaseApiUrl: "https://api.rechargeapps.com",
  rechargeApiVersion: "2021-01",

  loyaltyLionBaseApiUrl: "https://api.loyaltylion.com/v2",
  loyaltyLionApiToken: "2e3d0b9e9c9aa5b66548e25460741d65",

  gorgiasHelpChatAppId: "4309",
  siteCurrencyCode: "AUD",
  TEMP_CONTROL_POUCH_ID: "37653364244671",
}
